import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { mdiArrowLeft } from '@mdi/js'
import { FormattedMessage, useIntl } from 'react-intl'

import routes from 'app/routes'
import { useAppSelector } from 'app/hooks'

import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'
import {
  StyledBackButton,
  StyledBackButtonText,
  StyledBackButtonWrapper,
  StyledMBackIcon,
} from 'components/AsideMenu/BackButton/styles'
import { backButtonMessages } from './messages'

function BackButton() {
  const history = useHistory()
  const { formatMessage } = useIntl()

  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  const handleClick = useCallback(() => {
    history.push(routes.homesJobs(currentRootId))
  }, [history, currentRootId])

  return (
    <StyledBackButtonWrapper>
      <StyledBackButton
        onClick={handleClick}
        title={formatMessage(backButtonMessages.title)}
      >
        <StyledMBackIcon path={mdiArrowLeft} size={1} />
        <StyledBackButtonText>
          <FormattedMessage {...backButtonMessages.title} />
        </StyledBackButtonText>
      </StyledBackButton>
    </StyledBackButtonWrapper>
  )
}

export default BackButton
